import { rootEventBus, EnumRootEventBus } from "../../../../../../src/managers/RootEventBus";
import { eventBus, EnumEventBus } from "../EventBus";
import PointManager from "../PointManager/PointManager";
import AngleManager from "../AngleManager/AngleManager";
import LineManager from "../LineManager";
import { runCircleAnimation } from "./CircleAnimationSequence";
import Circle from "../../../../../../src/entities/Circle";
import CircleAnimationButton from "../../../../../../src/entities/UI/CircleAnimationButton/CircleAnimationButton";
import { Coord } from "../../../../../../src/types/Interface";
import { ContextType } from "../../types/Interface";
import { INFO_SLIDER_COORD } from "../../types/Config";


export default class CircleAnimationManager {
  private isKiteMode: boolean = false;
  private isT1Mode: boolean = false;
  private isT2Mode: boolean = false;

  constructor(
    private PointManager: PointManager,
    private AngleManager: AngleManager,
    private LineManager: LineManager,
    private circle: Circle,
    private cCoord: Coord,
  ) {
    const interSecCoord = PointManager.getIntersecCoord()
    this.AngleManager.draw(PointManager.getRedPoints(), interSecCoord, true);
    this.addCircAnimBut();

    eventBus.on(EnumEventBus.KiteMode, v => this.isKiteMode = v);
    eventBus.on(EnumEventBus.Triangle1Mode, v => this.isT1Mode = v);
    eventBus.on(EnumEventBus.Triangle2Mode, v => this.isT2Mode = v);
  }
  getDelayForStartAnim = () => (this.isKiteMode || this.isT1Mode || this.isT2Mode) ? 600 : 0;
  addCircAnimBut = () =>new CircleAnimationButton(INFO_SLIDER_COORD, () => this.runAnimations(), () => this.getDelayForStartAnim())

  runAnimations() {
    rootEventBus.emit(EnumRootEventBus.startedCircleAnim);
    const context: ContextType = {
      PointManager: this.PointManager,
      AngleManager: this.AngleManager,
      LineManager: this.LineManager,
      circle: this.circle,
      cCoord: this.cCoord
    }

    runCircleAnimation(context, () => {
      rootEventBus.emit(EnumRootEventBus.getCircleCoord, { x: this.circle.x, y: this.circle.y })
      rootEventBus.emit(EnumRootEventBus.completedCircleAnim);
    });
  }
}
